<script setup lang="ts">
import {
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonItemGroup,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonTitle,
  IonToolbar
} from '@ionic/vue';

import router from "@/router";
import {appsOutline, arrowBackOutline, bookOutline, documentTextOutline, personCircleOutline} from "ionicons/icons";
import {inject, onUnmounted, ref, watch, watchEffect} from "vue";
import {IAuthPlugin} from "@/plugins/auth/auth";
import {RouteRecordNameGeneric} from "vue-router";
import LocalStorage from "@/services/LocalStorage";

const version = __APP_VERSION__;

const auth = inject('auth') as IAuthPlugin;
//const config = auth.getConfig();
const config = ref(await auth.getConfig());
const showPermisoMenu = ref(false);
const showCourseMenu = ref(false);
const showTestMenu = ref(false);
const workspaceId = ref("");
const courseId = ref("");

const currentPath = router.currentRoute.value.name;


const logout = async () => {
  const menu = document.getElementById('main-menu') as HTMLIonMenuElement;
  menu.setOpen(false);
  await LocalStorage.removeItem('config');
  await LocalStorage.removeItem('token');
  await LocalStorage.removeItem('workspace_selected');
  await LocalStorage.removeItem('course_selected')
  await LocalStorage.clear();

  router.clearRoutes();
  window.location.reload();

}
const routeMenuResolve = async (currentPathName: RouteRecordNameGeneric) => {
  config.value = await auth.getConfig();

  switch (currentPathName) {
    case 'Temario del curso':
      showPermisoMenu.value = true;
      showCourseMenu.value = true;
      showTestMenu.value = false;
      workspaceId.value = await LocalStorage.getItem('workspace_selected')!;
      break;

    case 'Lista de cursos':
    case 'Test':
      showPermisoMenu.value = true;
      showCourseMenu.value = true;
      showTestMenu.value = true;
      workspaceId.value = await LocalStorage.getItem('workspace_selected')!;
      courseId.value = await LocalStorage.getItem('course_selected')!;
      break;

    case 'Espacios':
    default:
      showPermisoMenu.value = true;
      showCourseMenu.value = false;
      showTestMenu.value = false;
      workspaceId.value = "";
      break;
  }
};

routeMenuResolve(currentPath);

watchEffect(() => {
  const unwatch = watch(router.currentRoute, (to) => routeMenuResolve(to.name));
  onUnmounted(() => {
    unwatch();
  });
});

</script>

<template>

  <ion-menu id="main-menu" isOpen content-id="main-content">
    <ion-header>
      <ion-toolbar>
        <div class="header-menu">
          <ion-title>Menú</ion-title>
        </div>

      </ion-toolbar>
    </ion-header>
    <ion-content class="content-menu">

      <ion-list>
        <ion-menu-toggle>
          <ion-item v-if="showPermisoMenu" button @click="() => router.push('/workspaces')">
            <ion-icon aria-hidden="true" slot="start" :icon="appsOutline"></ion-icon>
            <ion-label>Espacios</ion-label>
          </ion-item>

          <ion-item v-if="showCourseMenu" button
                    @click="() => router.replace(`/workspace/${workspaceId}/cursos`)">
            <ion-icon aria-hidden="true" slot="start" :icon="bookOutline"></ion-icon>
            <ion-label>Temario</ion-label>
          </ion-item>

          <ion-item v-if="showTestMenu" button
                    @click="() => router.replace(`/courses/${courseId}`)">
            <ion-icon aria-hidden="true" slot="start" :icon="documentTextOutline"></ion-icon>
            <ion-label>Test</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>


      <div class="menu-botton ion-margin-bottom">
        <ion-list>
          <ion-item-group>
            <hr style="background: #c0c0c0; height: 1px; width: 100%;"/>
            <ion-item lines="none" v-if="config">
              <ion-icon slot="start" :icon="personCircleOutline"></ion-icon>
              <ion-label>{{ config?.user?.name }}</ion-label>
            </ion-item>

            <ion-item @click="logout" lines="none" class="">
              <ion-icon aria-hidden="true" slot="start" :icon="arrowBackOutline"></ion-icon>
              <ion-label>Salir</ion-label>
            </ion-item>

            <ion-item lines="none" class="ion-margin-bottom">
              <ion-icon aria-hidden="true" slot="start" :icon="arrowBackOutline" style="visibility: hidden;"></ion-icon>
              <ion-label class="ion-no-margin" style="color: dimgrey; font-size: 0.85rem">{{ version }}</ion-label>
            </ion-item>
          </ion-item-group>
        </ion-list>

      </div>
    </ion-content>
  </ion-menu>

</template>

<style scoped>

.header-menu {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;

  gap: 10px;
}

.content-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.menu-botton {
  position: absolute;
  width: 100%;
  bottom: 0;
}

</style>